import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import AvailableFields from './AvailableFields';

import DragDropHelpers, { replaceFieldsInHtml } from './DragDropHelpers';

class NumberInput extends Component {

    state = {
        value: undefined,
        checked: false,
        mapped: false,
        initialized: false
    }

    constructor() {
        super()
        this.onChange = this.onChange.bind(this)

        this.myRef = React.createRef();
        this.addFieldRef = React.createRef()
    }

    componentDidMount() {
        this.componentDidUpdate()
    }
    componentDidUpdate() {
        if (this.props.inputTypes && this.props.inputTypes.length > 0 && !this.dragDropHelpers && this.myRef) {
            this.dragDropHelpers = new DragDropHelpers(this.props.inputTypes, this.onChange, this.myRef, this.addFieldRef, true, true, ["long", "text"])

            if (this.props.value) {
                this.myRef.current.addEventListener("dragstart", this.dragDropHelpers.dragStartWithRemoving);
                this.myRef.current.addEventListener("dragend", this.dragDropHelpers.dragEndWithRemoving);

                this.dragDropHelpers.readValueAndInitializeComponents(this.props.value)
            }

            this.myRef.current.addEventListener("drop", this.dragDropHelpers.drop)
            this.myRef.current.addEventListener("dragover", this.dragDropHelpers.dragOver)
            this.setState({initialized:false})
        }
        if (this.props.value && !this.state.initialized) {
            if (isNaN(this.props.value)) {
                if (this.props.inputTypes && !this.dragDropHelpers) {
                    this.setState({ mapped: true, initialized: true })
                }
            } else {
                this.setState({ value: this.props.value, initialized: true })
            }
        }
    }

    onChange = (e) => {
        var html = this.myRef.current.innerHTML
        var value = undefined
        if (e && e.target.value) {
            value = e.target.value
            if (value.length > 15) {
                value = value.substring(0, 15)
            }
            html = value
        }
        var mapped = false
        if (html !== this.lastHtml) {
            html = replaceFieldsInHtml(html)

            if (value && html !== value) {
                mapped = true
            }
            this.props.onChange(html)
        }
        this.lastHtml = html

        this.setState({ value, mapped })
    }

    render() {
        const { t } = this.props;

        return <div>
            {this.dragDropHelpers ?
                <div className="d-flex" onDrop={this.dragDropHelpers.drop} onDragOver={this.dragDropHelpers.dragOver}>
                    {this.state.mapped
                        ? ""
                        : <input type="number" className="form-control w-270" onChange={this.onChange} value={this.state.value} />}
                    <label ref={this.myRef}></label>
                    {this.props.inputTypes && this.props.inputTypes.length > 0 ? <>
                        <button
                            id="dropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            className="icon-button field-add-button"
                            title={t("tip_field_select")}
                            style={this.state.mapped ? { "top": "4px" } : {}}
                        ><i className="fas fa-caret-down"></i></button>

                        <div className="dropdown-menu field-selector" aria-labelledby="dropdownMenuLink" ref={this.addFieldRef} >
                            {this.dragDropHelpers ? <AvailableFields types={this.props.inputTypes} onFieldClick={this.dragDropHelpers.replaceField} dataTypes={["long", "text"]} /> : ""}
                        </div>
                    </>
                        : ""}
                </div>
                :
                <>
                    <input type="number" className="form-control w-270" onChange={this.onChange} value={this.state.value} />
                    <label ref={this.myRef}></label>
                </>
            }

        </div>
    }
}

export default withTranslation()(NumberInput)